// extracted by mini-css-extract-plugin
export default {"coin_search":"CoinSearch_coin_search__xx5so","coin_search_input":"CoinSearch_coin_search_input__qnOun"};